const style = (theme) => ({
  root: {
    marginTop: 100,
    marginBottom: 100,
    [theme.mq.sm]: {
      marginTop: 50,
      marginBottom: 50,
    },
    '& .grid': {
      gap: 50,
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
  },
  pretitle: {
    marginBottom: 0,
  },
  embla: {
    marginTop: '0 !important',
  },
  postGrid: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
    gap: 60,
    [theme.mq.sm]: {
      gridTemplateColumns: 'repeat(auto-fit, minmax(100%, 1fr))',
      gap: 30,
    },
  },
  postImage: {
    height: 'auto',
    aspectRatio: '400/480',
    overflow: 'hidden',
    position: 'relative',
    zIndex: 1,
    display: 'block',
    '& img': {
      position: 'absolute',
      zIndex: 1,
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  postContent: {
    marginTop: 32,
    display: 'flex',
    flexDirection: 'column',
    gap: 22,
    '& h4': {
      margin: 0,
      '& a': {
        textDecoration: 'none',
        color: theme.colors[2],
      },
    },
    '& p': {
      margin: 0,
      color: theme.colors[6],
    },
  },
})

export default style
